import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from 'react';

import useApiCall from '../system/useApiCall';
import LinkService from '../system/LinkService';
import { Autocomplete, Checkbox, Chip, FormControlLabel, FormGroup } from '@mui/material';
import BotCommandTO from './BotCommandTO';
import Util from '../system/Util';

interface BotCommandDataDialogProps {
  editData?: BotCommandTO;
  openDialog: boolean;
  setEditRow: React.Dispatch<React.SetStateAction<number | null>>;
  saveCount: number;
  setSaveCount: React.Dispatch<React.SetStateAction<number>>;
}

export default function BotCommandDataDialog(props: BotCommandDataDialogProps) {
  const apiCall = useApiCall();
  const botCommandNewDataInit: BotCommandTO = {
    id: -1,
    name: '',
    description: '',
    usage: '',
    aliases: [],
    cooldownSeconds: 0,
    lastExecuted: new Date(),
    enabled: false,
  };
  const [botCommandData, setBotCommandData] = useState<BotCommandTO>(
    props.editData ? props.editData : botCommandNewDataInit
  );
  const [nameError, setNameError] = useState("");
  const [aliasesError, setAliasesError] = useState("");

  const validate = () => {
    let valid = true;
    if (!botCommandData.name.startsWith("!")) {
      setNameError("Command muss mit ! beginnen");
      valid = false;
    } else {
      setNameError("");
    }
    if (botCommandData.aliases.some(a => !a.startsWith("!"))) {
      setAliasesError("Alle Aliases müssen mit ! beginnen");
      valid = false;
    } else {
      setAliasesError("");
    }
    return valid;
  };

  React.useEffect(() => {
    if (props.editData) {
      setBotCommandData(props.editData);
    }
  }, [props.editData]);

  const handleCancel = () => {
    handleClose();
  };

  const handleSave = () => {
    if (!validate()) return;
    console.log(botCommandData);
    apiCall.post(LinkService.botCommandPost(), botCommandData, 'Speichern erfolgreich.').then((data) => {
      handleClose();
      props.setSaveCount(props.saveCount + 1);
    });
  };

  const handleClose = () => {
    setBotCommandData(botCommandNewDataInit);
    props.setEditRow(null);
  };

  const title = botCommandData.id === -1 ? 'Neuen Command hinzufügen' : 'Command bearbeiten';
  return (
    <Dialog open={props.openDialog}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          margin='dense'
          id='command'
          label='Command'
          fullWidth
          variant='standard'
          value={botCommandData.name}
          onChange={(e) => setBotCommandData({ ...botCommandData, name: e.target.value })}
          error={!!nameError}
          helperText={nameError}
        />{' '}
        <TextField
          margin='dense'
          id='description'
          label='Beschreibung'
          fullWidth
          variant='standard'
          value={botCommandData.description}
          onChange={(e) => setBotCommandData({ ...botCommandData, description: e.target.value })}
        />{' '}
        <TextField
          margin='dense'
          id='usage'
          label='Hilfe'
          fullWidth
          variant='standard'
          value={botCommandData.usage}
          onChange={(e) => setBotCommandData({ ...botCommandData, usage: e.target.value })}
        />{' '}
        <Autocomplete
          multiple
          freeSolo
          options={[]} // keine Vorschläge nötig, weil freie Eingabe
          value={botCommandData.aliases}
          onChange={(event, newValue) =>
            setBotCommandData({ ...botCommandData, aliases: newValue.filter(a => typeof a === "string") as string[] })
          }
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Aliases"
              placeholder="Alias hinzufügen und Enter drücken"
              error={!!aliasesError}
              helperText={aliasesError}
            />
          )}
        />
        <TextField
          margin='dense'
          id='cooldownSeconds'
          label='Cooldown in Sekunden'
          fullWidth
          variant='standard'
          type='number'
          value={botCommandData.cooldownSeconds}
          onChange={(e) => setBotCommandData({ ...botCommandData, cooldownSeconds: Util.isStringInt(e.target.value) ? Util.parseStringToInt(e.target.value) : 0,
            })
          }
        />{' '}
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={botCommandData.enabled}
                onChange={(e) => setBotCommandData({ ...botCommandData, enabled: e.target.checked })}
              />
            }
            label='aktiv'
          />
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Abbrechen</Button>
        <Button onClick={handleSave}>Speichern</Button>
      </DialogActions>
    </Dialog>
  );
}
